module.exports = __webpack_public_path__ + "static/img/011.46ed903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/011.jpg
// module id = uF00
// module chunks = 0